import { mapState, mapGetters, mapActions } from 'vuex'

export const measureDetailsComputed = {
  ...mapState('measureDetails', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('measureDetails', ['getMeasureDetails']),
}

export const measureDetailsMethods = mapActions('measureDetails', [
  'getDetailsById',
  'deleteMeasureById',
])
